import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../../constants'
import { convertEpochToDate } from '../../../utils/utils'
import { GROUPED_STATIC_TEXT_ROLE } from '../../ui-components/NameValueTableRow'

type FundManagerPropTypes = {
  name: string
  date: string
  isNew?: boolean
  linkedinUrl?: string | null
  twitterUrl?: string | null
  isBorderBottom?: boolean
}

export default function FundManager({
  name,
  date,
  isNew,
  linkedinUrl,
  twitterUrl,
  isBorderBottom
}: FundManagerPropTypes) {
  return (
    <div
      className='flex gap-[16px] w-full'
      role={GROUPED_STATIC_TEXT_ROLE}
      aria-label={`${name}${isNew ? ', New' : ''}, Since ${convertEpochToDate(+date, '%b %Y')}`}
    >
      <div aria-hidden='true' className='h-[40px] w-[40px]'>
        <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/fund-manager-icon.svg`} alt='' className='h-full w-full' />
      </div>
      <div
        aria-hidden='true'
        className={`flex flex-1 justify-between pb-[16px] ${isBorderBottom ? 'border-b border-[#EBF2F2]' : ''}`}
      >
        <div className='flex flex-col'>
          <div className='font-[500] flex gap-[8px] items-center'>
            <div>{name}</div>
            {isNew && (
              <div className='bg-[#E4FBEA] rounded-[6px] h-[16px] px-[6px] pb-[2px] text-[#0B6B2A] flex items-center text-[11px]'>
                New
              </div>
            )}
          </div>
          <div className='font-[400] text-[#6A6E6E]'>Since {convertEpochToDate(+date, '%b %Y')}</div>
        </div>
        <div className='flex items-center gap-[16px]'>
          {twitterUrl && (
            <div className='h-[18px] w-[18px]'>
              <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/twitter-icon.svg`} alt='' className='h-full w-full' />
            </div>
          )}
          {linkedinUrl && (
            <div className='h-[18px] w-[18px]'>
              <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/linkedin-icon.svg`} alt='' className='h-full w-full' />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
